export default {
  validate: value => {
    var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[0-9])(?=.{8,})');
    return strongRegex.test(value);
  },
  message: `Не менее 8 символов. Должен содержать цифры и буквы`
};
